import { render, staticRenderFns } from "./LinkedModel.vue?vue&type=template&id=5927e4a0&scoped=true&"
import script from "./LinkedModel.vue?vue&type=script&lang=ts&"
export * from "./LinkedModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927e4a0",
  null
  
)

export default component.exports